import type React from 'react';
import { useEffect, useState } from 'react';

type TypewriterProps = {
  text: string;
  onComplete: () => void;
  typingSpeed?: number;
};

export const Typewriter: React.FC<TypewriterProps> = ({
  text,
  onComplete,
  typingSpeed,
}) => {
  const [index, setIndex] = useState<number>(0);
  const [onCompleteCalled, setOnCompleteCalled] = useState<boolean>(false);

  useEffect(() => {
    if (index < text.length) {
      const timer = setTimeout(() => {
        setIndex((prevIndex) => prevIndex + 1);
      }, typingSpeed);
      return () => clearTimeout(timer);
    }

    if (index === text.length && !onCompleteCalled) {
      onComplete();
      setOnCompleteCalled(true);
    }

    return undefined;
  }, [index, text, onComplete, onCompleteCalled, typingSpeed]);

  // biome-ignore lint/correctness/useExhaustiveDependencies: <explanation>
  useEffect(() => {
    setIndex(0); // textが変更されたらインデックスをリセットしてアニメーションをやり直し
    setOnCompleteCalled(false);
  }, [text]);

  return <>{text.substring(0, index)}</>;
};

export default Typewriter;
